export default {"src":"/_next/static/image/public/images/ic_info_purple.4a1df412bbd9ac12a9662401b62d0c56.svg","height":20,"width":20};